import React, { CSSProperties } from 'react';
import { formatTimestamp } from '../utils/formatTimestamp';

interface Props {
  profilePic?: string | null;
  username: string;
  timestamp: string;
  variant?: 'overlay' | 'standard';
}

export default function UserInfoOverlay({
  profilePic,
  username,
  timestamp,
  variant = 'overlay'
}: Props): React.ReactElement {
  const isOverlay = variant === 'overlay';

  if (isOverlay) {
    return (
      <div style={styles.overlayContainer}>
        <div style={styles.userInfo}>
          {profilePic && (
            <img
              src={profilePic}
              alt={`${username}'s profile`}
              style={styles.profilePic}
            />
          )}
          <div style={styles.userDetails}>
            <h3 style={styles.username}>@{username}</h3>
            <p style={styles.timestamp}>{formatTimestamp(timestamp)}</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div style={styles.standardContainer}>
      {profilePic && (
        <img
          src={profilePic}
          alt={`${username}'s profile`}
          style={styles.profilePicStandard}
        />
      )}
      <div style={styles.userDetails}>
        <h3 style={styles.username}>@{username}</h3>
        <p style={styles.timestamp}>{formatTimestamp(timestamp)}</p>
      </div>
    </div>
  );
}

const styles: Record<string, CSSProperties> = {
  overlayContainer: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.35)',
    padding: '12px 8px',
    zIndex: 10,
    pointerEvents: 'none',
  },
  userInfo: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
  },
  profilePic: {
    width: '40px',
    height: '40px',
    borderRadius: '50%',
    objectFit: 'cover',
  },
  userDetails: {
    display: 'flex',
    flexDirection: 'column',
  },
  username: {
    margin: 0,
    fontSize: '14px',
    fontWeight: 600,
    color: '#ffffff',
  },
  timestamp: {
    margin: 0,
    fontSize: '12px',
    color: '#ffffff',
  },
  standardContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
  },
  profilePicStandard: {
    width: '50px',
    height: '50px',
    borderRadius: '50%',
    objectFit: 'cover',
  },
};
